import { Component, Input, ChangeDetectionStrategy } from '@angular/core';

import { ListsComponent } from '../../lists.shared.component';

import { Observable } from 'rxjs';

@Component({
    selector: 'shared-list-for-loyalty-program-products-counter',
    templateUrl: './list-for-loyalty-program-products-counter.shared.component.html',
    styleUrls: ['./list-for-loyalty-program-products-counter.shared.component.scss'],
    // changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ListForLoyaltyProgramProductsCounterComponent extends ListsComponent {
    @Input() public size: number = 150;
    @Input() public programProducts: OLO.Ordering.ILoyaltyProgramProductItemModel[];
    @Input() public loyaltyPoints: OLO.Ordering.ILoyaltyPointsModel;

    constructor() {
        super();
        this.placeholders = 2;
    }

    public get isEmpty(): boolean {
        if (this.programProducts && this.programProducts.length === 0) return true;
        return false;
    }

    public trackBy(index: number, item: OLO.Ordering.ILoyaltyProgramProductItemModel): number {
        return item?.product?.Id || index;
    }
}
